// extracted by mini-css-extract-plugin
module.exports = {"serviceQuestions":"service-questions-module--serviceQuestions--32nL5"};